/**
 * Converts an arraybuffer response into an object URL, inferring the MIME type
 * from either a full MIME string or a bare file extension.
 */
export const convertImage = (imageData, imageType) => {
	const arrayBufferView = new Uint8Array(imageData);

	let mimeType;
	if (!imageType) {
		mimeType = 'image/png';
	} else if (imageType.includes('/')) {
		mimeType = imageType;
	} else {
		switch (imageType.toLowerCase()) {
			case 'jpeg':
			case 'jpg':
				mimeType = 'image/jpeg';
				break;
			case 'webp':
				mimeType = 'image/webp';
				break;
			default:
				mimeType = `image/${imageType}`;
		}
	}

	const blob = new Blob([arrayBufferView], { type: mimeType });
	const urlCreator = window.URL || window.webkitURL;
	return { url: urlCreator.createObjectURL(blob), blob };
};
